// libs
import $ from "jquery";
import TweenMax from "TweenMax";
import { Linear, Power3 } from "EasePack";

// local
import PageBase from "./PageBase";
import { SlideApp } from "../modules";
import { CalendarApp, ModalCalendarApp } from "../modules";

export default class HomeApp extends PageBase {
  constructor() {
    super();
  }

  init() {
    super.init();

    this.initTopElements();

    const slide = new SlideApp();
    slide.dispatcher.bind("init", () => {
      // setTimeout(() => {
      //   $(window).scrollTop(0);
      // }, 10);
      slide.start();
      TweenMax.to("#js-stage ", 1, {
        opacity: 1,
        ease: Linear.easeNone,
        onComplete: () => {
          this.showTopElements();
        }
      });
    });

    slide.init();

    this.calendar = new CalendarApp();
    this.calendar.dispatcher.bind("init", () => {});
    this.calendar.init();

    this.modalCalendar = new ModalCalendarApp();
    this.modalCalendar.dispatcher.bind("init", () => {});
    this.modalCalendar.init();

    this.initFadeAnimation();
    this.initHeaderColorChange();
  }

  initTopElements() {
    $("#js-copy").css({ transform: "translateY(50px)", opacity: 0 });
    $("#js-header").css({ opacity: 0 });
    $("#js-header").hide();
  }

  showTopElements() {
    const DELAY = 1000;

    setTimeout(() => {
      TweenMax.to("#js-copy", 2, {
        opacity: 1,
        y: 0,
        ease: Power3.easeOut
      });

      TweenMax.to("#js-header", 2, {
        opacity: 1,
        ease: Power3.easeOut,
        delay: 1
      });

      $("#js-header").show();
    }, DELAY);
  }
}



// WEBPACK FOOTER //
// ./src/js/apps/pages/HomeApp.js